import { ComponentIds } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages } from '@inter-ikea-storageone/range';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import {
  hideNoDoorsInSceneErrorMessage,
  hideNoFramesInSceneErrorMessage
} from 'rangeConfig/shared/rules/hideMenuRules';
import { hidePlatsaAddingFrontToOpenFrameErrorMessage } from '../../platsa/rules/hideMenuRules';

const dragAndDropHandlesBehavior = ({
  coreApi,
  dispatch,
  props,
  rootState
}: BehaviorParameters) => {
  const frontAtPosition = coreApi.entities.getEntityClosestToPosition(props.position, [
    ComponentIds.DOOR_FRONT_COMPONENT_ID
  ]);

  const determinePlacementAttemptErrorMessage = () => {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoFramesInScene;
    } else if (!hidePlatsaAddingFrontToOpenFrameErrorMessage(coreApi)) {
      return ErrorMessages.PlatsaAddingHandlesToOpenFrames;
    } else if (!hideNoDoorsInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoDoorsInScene;
    }
    return null;
  };
  const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  if (!frontAtPosition) {
    return;
  }

  addProduct({ dispatch, coreApi, props, rootState });
};

export { dragAndDropHandlesBehavior };
